import { gql } from '@apollo/client'
import { Domiciliation } from 'globals/models/Domiciliation'

export const QUIETS_LIST = gql`
  query quietsList($page: Int!) {
    quietsList(
      page: $page
    ) {
      id
      firstname
      lastname
      email
      status
      clientSince
      address {
        id
        shortname
        fullAddress
      }
      forwardingAddress {
        id
        name
        streetAddress
        postalCode
        city
        country
      }
      mailForwardingFrequency
      pendingUserMailsCount
      phoneNumber
      postalProcurationReady
      society {
        id
        name
        legalStatus
        brandName
      }
      userMailOption
      leaderEmail
      leaderPhoneNumber
    }
  }
`

export interface QuietsListVariables {
  page: number
}

export interface QuietsListResult {
  quietsList: Domiciliation[]
}
